module.exports={
    baseUrl : 'https://api-bridge-assesment.bridgeindonesia.id/api/',
}